
import {getCreditHisotry} from '../api/getCreditHisotry';
import {setGetCreditHistoryAction} from '../action';

const setGetCreditHisotry = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getCreditHisotry(params);

            if (data.status === 'success') {
                dispatch(setGetCreditHistoryAction({
                    list: data.list,
                    page: data.countPage
                }));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetCreditHisotry
}